export const COLORS = {
    primary: {
        dark: '#0A0A5F',
        light: '#183590',
        button: '#1C429E',
    },
    error: {
        main: '#C7222A',
    },
    success: {
        main: '#2AAB59',
    },
    background: {
        default: '#FFFFFF',
        paper: '#FFFFFF',
        infoBox: '#E8ECF8', // Info box background
    },
    text: {
        primary: '#000000',
        secondary: '#333333',
        disabled: '#666666',
    },
    border: {
        infoBox: '#E8ECF8', // Info box border
    },
    neutral: {
        medium: '#9E9E9E',
        light: '#e0e0e0',
    },
    gradients: {
        primary: 'linear-gradient(90deg, #0A0A5F 0%, #183590 100%)',
        button: 'linear-gradient(90deg, #1C429E 0%, #0A0A5F 100%)',
    },
    shadow: {
        infoBox: '0px 0px 20px 0px #EDF1FF', // Info box shadow
        actionFooter: '0px 0px 15px 0px #C3CFF0',
    },
};
